export const EXCMCHATBOT_SHOW_RESET = 'EXCMCHATBOT_SHOW_RESET'
export const EXCMCHATBOT_SHOW_SET_ERROR = 'EXCMCHATBOT_SHOW_SET_ERROR'
export const EXCMCHATBOT_SHOW_SET_RETRIEVED = 'EXCMCHATBOT_SHOW_SET_RETRIEVED'
export const EXCMCHATBOT_SHOW_TOGGLE_LOADING = 'EXCMCHATBOT_SHOW_TOGGLE_LOADING'
